import Image from 'next/image';
import React from 'react';

const IntegrationsTechAiAgents = () => {
    return (
        <div className="section-py !pt-0 !pb-0 dark:bg-black">
            <div className="container lg:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="lg:col-span-10 pb-10">
                        <h2 className="mb-4 dark:text-white" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            Integrations & Tech Stack
                        </h2>
                        <p className='mb-0' data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            Our Conversational AI & RAG solutions are built on a modular, open, and scalable technology architecture that adapts easily to any enterprise IT ecosystem. We integrate seamlessly with the best-of-breed LLM APIs, open-source models, and high-performance vector databases to deliver robust, production-ready systems
                        </p>
                    </div>
                </div>
                 <div className="row grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-3 mb-[30px]">
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/ai-agent/svg/ic-orchestration-framework.svg"
                                width={36}
                                height={36}
                                alt="Orchestration Frameworks"
                            />
                        </div>
                        <p className="fw-700 dark:text-white mb-1">Orchestration Frameworks</p>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            LangChain, LangGraph, CrewAI, AutoGen, LlamaIndex, enabling scalable multi-agent workflows and advanced task orchestration.
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                        <div className="voice-generator-box mb-3">
                            <Image src="/img/ai-agent/svg/ic-mcp-protocol.svg" width={36} height={36} alt="MCP Protocol" />
                        </div>
                        <p className="fw-700 dark:text-white mb-1">MCP Protocol</p>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            Comprehensive Model Context Protocol server/client implementations and custom connector development for secure cross-system communication.
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/ai-agent/svg/ic-llm-integration.svg"
                                width={36}
                                height={36}
                                alt="LLM Integration"
                            />
                        </div>
                        <p className="fw-700 dark:text-white mb-1">LLM Integration</p>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                           Industry-leading large language models, including OpenAI GPT-4, Anthropic Claude, Azure OpenAI, and custom fine-tuned models for adaptive intelligence.
                        </p>
                    </div>
                </div>
                <div className="row grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-3 mb-[30px]">
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/ai-agent/svg/ic-vector-database.svg"
                                width={36}
                                height={36}
                                alt="Vector Databases"
                            />
                        </div>
                        <p className="fw-700 dark:text-white mb-1">Vector Databases</p>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            Pinecone, Milvus, Chroma, and FAISS utilized for agent memory management and efficient context retrieval.
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/ai-agent/svg/ic-rpa-tools.svg"
                                width={36}
                                height={36}
                                alt="RPA Tools"
                            />
                        </div>
                        <p className="fw-700 dark:text-white mb-1">RPA Tools</p>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            UiPath, Automation Anywhere, and Power Automate integrated to blend robotic and AI automation capabilities into cohesive workflows.
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/ai-agent/svg/ic-minitoring-&-observation.svg"
                                width={36}
                                height={36}
                                alt="Monitoring & Observability"
                            />
                        </div>
                        <p className="fw-700 dark:text-white mb-1">Monitoring & Observability</p>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                            LangSmith, Weights & Biases, custom audit dashboards, Prometheus, and Grafana provide real-time insights, auditability, and system health tracking.
                        </p>
                    </div>
                </div>
                 <div className="row grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-3">
                    
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                        <div className="voice-generator-box mb-3">
                            <Image src="/img/ai-agent/svg/ic-low-code-platforms.svg" width={36} height={36} alt="Low-Code Platforms" />
                        </div>
                        <p className="fw-700 dark:text-white mb-1">Low-Code Platforms</p>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                           Microsoft Power Platform (Power Automate AI Builder), Make (Integromat) to empower citizen developers and speed deployments.
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/ai-agent/svg/ic-integration-tools.svg"
                                width={36}
                                height={36}
                                alt="Integration Tools"
                            />
                        </div>
                        <p className="fw-700 dark:text-white mb-1">Integration Tools</p>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                           Zapier, Power Automate for simple agent workflow automation and rapid app connections.
                        </p>
                    </div>
                    <div className="card p-5 dark:bg-[#3C45611A] dark:border-[#ffffff33] dark:border-solid" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                        <div className="voice-generator-box mb-3">
                            <Image
                                src="/img/ai-agent/svg/ic-security.svg"
                                width={36}
                                height={36}
                                alt="Security & Compliance Infrastructure"
                            />
                        </div>
                        <p className="fw-700 dark:text-white mb-1">Security & Compliance Infrastructure</p>
                        <p className="fs-md mb-0 fw-500 dark:text-[#D7DEE5]">
                           Enterprise-grade security with API gateways, encrypted credential management, end-to-end encryption, identity and access management with SSO, multi-factor authentication, and SOC 2 and GDPR compliance.
                        </p>
                    </div>
                </div>
               
            </div>
        </div>
    );
};

export default IntegrationsTechAiAgents;
